import { useEffect, useMemo } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import * as InsuranceActions from 'store/insurance/actions';
import * as InsuranceSelectors from 'store/insurance/selectors';

const RESET_ACTIONS = [
  InsuranceActions.resetData(),
  InsuranceActions.resetPages(),
  InsuranceActions.resetStages(),
];

export const useInsurancePresenter = () => {
  const dispatch = useDispatch();

  const errors = useSelector(InsuranceSelectors.selectPagesErrors);

  const error = useMemo(() => {
    return Object.values(errors).find(({ type }) => {
      return typeof type !== 'undefined';
    });
  }, [errors]);

  useEffect(() => {
    return () => {
      RESET_ACTIONS.forEach((action) => {
        dispatch(action);
      });
    };
  }, []);

  return { error };
};
